import React, { useState, useEffect } from 'react';
import './Modal.css';
import Button from '../Button/Button';

const ShoppingBagIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
    <path d="M3 6h18" />
    <path d="M16 10a4 4 0 01-8 0" />
  </svg>
);

const Modal = ({ isOpen, onClose, title, price, compare_at_price, size, images = [], children, actions }) => {
  const [currentImage, setCurrentImage] = useState(0);
  
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);
  
  if (!isOpen) return null;

  const hasMultiple = images.length > 1;
  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };
  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {images.length > 0 && (
          <div className="modal-image-gallery">
            <img src={images[currentImage]} alt={title} className="modal-gallery-image" />
            {hasMultiple && (
              <>
                <button className="modal-gallery-arrow left" onClick={handlePrev}>&lt;</button>
                <button className="modal-gallery-arrow right" onClick={handleNext}>&gt;</button>
                <div className="modal-gallery-thumbnails">
                  {images.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}
                      alt={title}
                      className={`modal-gallery-thumb${idx === currentImage ? ' active' : ''}`}
                      onClick={() => setCurrentImage(idx)}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        )}
        <div className="modal-body">
          {children}
          <div className="modal-info">
            <div className="modal-info-row">
              <div className="modal-label">Name:</div>
              <div className="modal-title">{title}</div>
            </div>
            {size && (
              <div className="modal-info-row">
                <div className="modal-label">Size:</div>
                <div className="modal-size">{size}</div>
              </div>
            )}
            {price && (
              <div className="modal-info-row">
                <div className="modal-label">Price:</div>
                <div className="modal-price-container">
                  {compare_at_price && compare_at_price > price && Math.round(((compare_at_price - price) / compare_at_price) * 100) > 0 ? (
                    <div className="modal-price-row">
                      <span className="modal-compare-price-strikethrough">Rs. {compare_at_price}</span>
                      <span className="modal-discount-percentage">
                        {Math.round(((compare_at_price - price) / compare_at_price) * 100)}% OFF
                      </span>
                      <span className="modal-price-clean">Rs. {price}</span>
                    </div>
                  ) : (
                    <span className="modal-price-clean">Rs. {price}</span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        {actions && (
          <div className="modal-actions">
            <Button
              onClick={() => {
                if (actions[0]?.onClick) actions[0].onClick();
                if (onClose) onClose();
              }}
              variant={actions[0]?.variant || 'primary'}
              size="small"
              className="modal-button primary"
            >
              <ShoppingBagIcon />
              {actions[0]?.label || 'Buy Now'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal; 